import React, { Component } from "react";
import { Divider } from "antd";

import CustomRadio from "./CustomRadio";

export default class CustomRadioGroup extends Component {
  render() {
    const { heading, choices, value, onClickRadio, last } = this.props;
    return (
      <div>
        <h2 className="title margin-bottom">{heading}</h2>
        {choices.map(choice => (
          // selected = (choice === value)
          <CustomRadio
            label={choice}
            key={choice}
            selected={value === choice}
            clickRadio={() => onClickRadio(heading, choice)}
          />
        ))}
        {!last && <Divider />}
      </div>
    );
  }
}
